import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import config from '../../../../config';
import { translate as t } from '../../../../lib/I18n';


export default function SmartcardAppIcons({
    toggleAppModal,
    isAppStoreIcon,
    isPlayStoreIcon,
}) {
    const brand = config.get('brand');

    return (
        <React.Fragment>
            {isAppStoreIcon && (
                <button onClick={toggleAppModal}>
                    <img
                        src="/images/mobile-apps/app-store-icon.png"
                        alt={t('ontrackapp.widget.appstoreButtonAltText')}
                    />
                </button>
            )}
            {isPlayStoreIcon && (
                <button onClick={toggleAppModal}>
                    <img
                        src="/images/mobile-apps/play-store-icon.png"
                        alt={t('ontrackapp.widget.googlePlayButtonAltText')}
                    />
                </button>
            )}
            <button onClick={toggleAppModal}>
                <img
                    className="app-logo"
                    src={`/images/logos/${brand}-logo.png`}
                    alt={t('ontrackapp.widget.brandAltText', { brand })}
                />
            </button>
        </React.Fragment>
    );
}

SmartcardAppIcons.propTypes = {
    toggleAppModal: PropTypes.func,
    isAppStoreIcon: PropTypes.bool,
    isPlayStoreIcon: PropTypes.bool,
};

SmartcardAppIcons.defaultProps = {
    toggleAppModal: _.noop,
    isAppStoreIcon: false,
    isPlayStoreIcon: false,
};



// WEBPACK FOOTER //
// ./src/components/checkout/delivery/smartcard/SmartcardAppIcons.js